if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStock extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.tags = this.querySelector('[data-bis-tags]');
        this.success = this.querySelector('[data-bis-success]');
        this.error = this.querySelector('[data-bis-error]');
        this.storageKey = 'naturall-bis-' + this.dataset.formId;

        // Only this form's own submission shows its success/error (the footer newsletter uses the same form type).
        const submittedHere = sessionStorage.getItem(this.storageKey) === '1';
        if (submittedHere) {
          sessionStorage.removeItem(this.storageKey);
          if (this.success && this.success.dataset.posted === 'true') {
            this.success.hidden = false;
            this.querySelector('.back-in-stock__row')?.setAttribute('hidden', '');
          } else if (this.error) {
            this.error.hidden = false;
          }
          if (window.location.hash === '#' + this.dataset.formId) this.scrollIntoView({ block: 'center' });
        }

        if (window.location.hash === '#notify' && !this.hidden) {
          requestAnimationFrame(() => {
            this.scrollIntoView({ block: 'center' });
            this.querySelector('input[type="email"]')?.focus({ preventScroll: true });
          });
        }

        this.form?.addEventListener('submit', () => sessionStorage.setItem(this.storageKey, '1'));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.section) return;
            this.update(event.data.variant);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      update(variant) {
        if (!variant) {
          this.hidden = true;
          return;
        }
        this.hidden = variant.available;
        if (this.tags) this.tags.value = 'back-in-stock,bis-' + variant.id;
      }
    }
  );
}
